const FormaContactoPreferida = props => {
    
    const state = props.state;

    return (
        <>
        <h5 className="mb-3 text-secondary">Forma de Contacto Preferida</h5>
        <div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-check">
                        {props.metodos.map((row,index) => {
                            return(
                                <div key={index}>
                                    <input className="form-check-input" type="radio" name="metodo_contacto" id={`metodo_contacto_${index}`} value={row.id} checked={parseInt(state.metodo_contacto) === parseInt(row.id)} onChange={e => props.handleOnChangeOption(e)} />
                                    <label className="form-check-label" htmlFor={`metodo_contacto_${index}`}>
                                        {row.descripcion}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {props.error.metodo_contacto && (
                        <div className="text-danger mt-1">{props.error.metodo_contacto}</div>
                    )}
                </div>
            </div>
        </div>
    </>
    );
  }
  
export default FormaContactoPreferida;